
import { Component, Vue } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import RouterUtil from '@/utils/router.util';
import UserAvatar from '@/components/UserAvatar.vue';
import DatetimeUtil from '@/utils/datetime.util';

@Component({
  components: {
    UserAvatar,
  },
})
export default class Menu extends Vue {
  showSidebar = false;
  currentDate: string = DatetimeUtil.longDate();
  routes: RouteConfig[] = [];

  get sidebarIcon(): string {
    return this.showSidebar ? 'x' : 'list';
  }

  get isSimulatingUser(): boolean {
    return this.$store.state.user.isSimulatingUser;
  }

  getChildPath(parent: RouteConfig, child: RouteConfig): string {
    return child.meta && child.meta.userAllowed
      ? `${parent.path}/${child.path}`
      : '';
  }

  routeLabel(route: RouteConfig): string {
    return RouterUtil.getRouteLabelAsString(route);
  }

  toogleSidebar(): void {
    this.showSidebar = !this.showSidebar;
  }

  async logout(): Promise<void> {
    if (this.isSimulatingUser) {
      await this.$store.dispatch('logoutSimulatedUser');
      await this.$router.push({ name: 'users' });
      this.$router.go(0);
      return;
    }

    await this.$store.dispatch('logout');
    this.$router.push({ name: 'logout' });
  }

  getMenuRoutes(): RouteConfig[] {
    const routes = RouterUtil.getNavigationRoutes(
      this.$store.state.user.userRoutes
    );
    const sortedRoutes = routes
      .filter((route) => route.meta?.active !== false)
      .sort((a, b) => {
        return Number(!!b.meta?.userAllowed) - Number(!!a.meta?.userAllowed);
      })
      .map((route) => {
        if (route.children && Array.isArray(route.children)) {
          route.children = route.children
            .filter(
              (child) =>
                child.meta?.active !== false &&
                (child.meta?.userAllowed ||
                  child.meta?.isAccessGloboButtonEnabled)
            )
            .slice()
            .sort((a, b) => {
              return (
                Number(!!b.meta?.userAllowed) - Number(!!a.meta?.userAllowed)
              );
            });
        }
        return route;
      });
    return sortedRoutes;
  }
  mounted(): void {
    this.routes = this.getMenuRoutes();
    this.$watch(
      () => this.$store.state.user.userRoutes,
      (newRoutes, oldRoutes) => {
        if (JSON.stringify(newRoutes) !== JSON.stringify(oldRoutes)) {
          this.routes = this.getMenuRoutes();
        }
      },
      { deep: true }
    );
  }
}
